import { Box } from '@zillow/constellation-10';

import { VIEW_TYPE } from './constants';

import { desktopContainerStyles, mobileContainerStyles } from './styles';

import { WizardTip } from './WizardTip';
import { WizardTipCard } from './WizardTipCard';

import type React from 'react';

type Props = {
  header: string;
  headerLevel?: 1 | 2 | 3 | 4 | 5 | 6;
  children: React.ReactNode;
  icon?: React.ReactNode;
  isPremiumTip?: boolean;
};

const WizardTipCardContainer = ({ header, headerLevel, children, icon = null, isPremiumTip }: Props) => {
  return (
    <aside aria-labelledby="tip-title">
      <Box css={mobileContainerStyles}>
        {isPremiumTip ? (
          <WizardTip viewType={VIEW_TYPE.CARD}>
            <WizardTipCard header={header} isPremiumTip={isPremiumTip}>
              {children}
            </WizardTipCard>
          </WizardTip>
        ) : (
          <WizardTip header={header} headerLevel={headerLevel} viewType={VIEW_TYPE.ACCORDION}>
            {children}
          </WizardTip>
        )}
      </Box>

      <Box css={desktopContainerStyles}>
        <WizardTip viewType={VIEW_TYPE.CARD}>
          {icon ? (
            <WizardTipCard header={header} icon={icon}>
              {children}
            </WizardTipCard>
          ) : (
            <WizardTipCard header={header} isPremiumTip={isPremiumTip}>
              {children}
            </WizardTipCard>
          )}
        </WizardTip>
      </Box>
    </aside>
  );
};

export default WizardTipCardContainer;
